"use client";

import { useRef, useState } from 'react';
import type { Swiper as SwiperType } from 'swiper'
import { Swiper, SwiperSlide } from "swiper/react"
import 'swiper/css'

export default function BannerHome() {
  const sectionCount: number = 6
  const [currentSection, setCurrentSection] = useState(0)
  const videoRef = useRef<HTMLVideoElement>(null)
  const [swiperInst, setSwiperInst] = useState<SwiperType | null>(null)

  const emotionArray = [ 'Delighted', 'Moved', 'Afraid', 'Ignited', 'Surprised', 'Challenged' ]

  const onDurationChangeHandler = () => {
    if (videoRef.current) {
      const progress = videoRef.current.currentTime / videoRef.current.duration
      const slideIndex = Math.min( Math.floor( progress / (1 / sectionCount)), (sectionCount - 1) )
      if ( slideIndex !== currentSection ) {
        setCurrentSection( slideIndex )
        swiperInst?.setProgress( slideIndex / (sectionCount - 1) ) 
      }
    }
  }

  return (
    <section className="section banner-home padding-vert-6xl">
      <div className="bg banner-arrow">
        <video 
          className="bg-video" 
          poster="./poster-banner-bg.png"
          autoPlay 
          loop 
          muted
          disablePictureInPicture 
          playsInline 
          controlsList="nofullscreen nodownload noremoteplayback"
        >
          <source src="./BIFF_Header_Background.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="corridor">

        <div className="banner-title">
          Brisbane International Film Festival
        </div>

        <div className="big-b">
          <video 
            className="big-b-video" 
            autoPlay loop muted 
            poster="./poster-banner.png" 
            ref={videoRef}
            onTimeUpdate={onDurationChangeHandler}
            disablePictureInPicture 
            playsInline 
            controlsList="nofullscreen nodownload noremoteplayback"
          >
            <source src="./BIFF_Header_Clips.mp4" type="video/mp4" />
          </video>
        </div>

        <div className="emotions">
          <ul>
            {emotionArray.map((emotionName: string, i) => {
              return ( <li key={emotionName} className={currentSection === i ? `active text-${emotionName.toLowerCase()}` : 'text-inactive'}>{emotionName}</li> )
            })}
          </ul>
        </div>

        <Swiper 
          className="emotions-mobile"
          slidesPerView={'auto'}
          spaceBetween={12}
          onSwiper={(swiper) => {
            setSwiperInst(swiper)
          }}
        >
          {emotionArray.map((emotionName: string, i) => {
            return ( <SwiperSlide key={emotionName} className={currentSection === i ? `active text-${emotionName.toLowerCase()}` : 'text-inactive'}>{emotionName}</SwiperSlide> )
          })}
        </Swiper>

      </div>
      <svg className="hidden-svg" xmlns="http://www.w3.org/2000/svg" version="1.1">
        <defs>
          <mask id="b-mask" viewBox="0 0 1 1" maskContentUnits="objectBoundingBox">
            <path fill="white" d="M.585.361c0,.035-.029.064-.064.064h-.146c-.035,0-.064-.029-.064-.064v-.068c0-.035.029-.064.064-.064h.146c.035,0,.064.029.064.064v.068ZM.585.707c0,.035-.029.064-.064.064h-.146c-.035,0-.064-.029-.064-.064v-.068c0-.035.029-.064.064-.064h.146c.035,0,.064.029.064.064v.068ZM.935.55c-.034-.032-.08-.052-.138-.059-.007,0-.014-.007-.014-.014,0-.009.005-.016.013-.017.027-.004.051-.012.072-.023.032-.017.057-.042.074-.074.017-.032.026-.069.026-.11,0-.069-.024-.124-.071-.165-.048-.041-.12-.061-.217-.061h-.097c-.006.03-.032.052-.063.052h-.146c-.031,0-.057-.023-.063-.052H.016c-.009,0-.016.007-.016.016v.915c0,.009.007.016.016.016h.296c.006-.03.032-.052.063-.052h.146c.031,0,.057.023.063.052h.091c.076,0,.138-.01.186-.031.048-.021.083-.05.105-.088.022-.038.033-.084.033-.138,0-.07-.022-.126-.065-.166"/>
          </mask>
        </defs>
      </svg>
    </section>
  )
}